export const LEGAL_UPDATED = "September 2026";

export const IMPRESSUM_SECTIONS = [
  {
    h: "Angaben gemäß § 5 DDG",
    p: ["SYPAMA Holding GmbH", "Turbinenstraße 8", "70499 Stuttgart", "Deutschland"],
  },
  {
    h: "Vertretung",
    p: ["Vertretungsberechtigter Geschäftsführer: Pablo Penzel"],
  },
  {
    h: "Kontakt",
    p: ["Telefon: 0151 26739096", "E-Mail: sypama.holding@yahoo.com"],
  },
  {
    h: "Registereintrag",
    p: [
      "Eingetragen im Handelsregister des Amtsgerichts Stuttgart",
      "Registernummer: HRB 805645",
    ],
  },
  {
    h: "Verantwortlich für den Inhalt",
    p: ["Pablo Penzel, Anschrift wie oben (§ 18 Abs. 2 MStV)"],
  },
  {
    h: "Haftung für Inhalte",
    p: [
      "Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden. Als Diensteanbieter ist die SYPAMA Holding GmbH gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
    ],
  },
  {
    h: "Haftung für Links",
    p: [
      "Diese Website enthält derzeit keine externen Links zu Websites Dritter. Sollten künftig externe Links gesetzt werden, gilt: Für die Inhalte verlinkter Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
    ],
  },
  {
    h: "Urheberrecht",
    p: [
      "Die auf dieser Website veröffentlichten Inhalte und Werke (Texte, Grafiken, Bildmaterial, Logo) unterliegen dem deutschen Urheberrecht. Jede Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung der SYPAMA Holding GmbH.",
    ],
  },
  {
    h: "Hinweis zu AGB und Widerruf",
    p: [
      "Diese Website dient ausschließlich der Unternehmensdarstellung. Über die Website werden keine Verträge geschlossen und keine kostenpflichtigen Leistungen, Produkte oder Abonnements angeboten. Daher werden keine Allgemeinen Geschäftsbedingungen (AGB) bereitgestellt und es besteht kein Widerrufsrecht im Sinne der Verbraucherschutzvorschriften.",
    ],
  },
];

export const DATENSCHUTZ_SECTIONS = [
  {
    h: "1. Verantwortlicher",
    p: [
      "Verantwortlicher im Sinne der DSGVO ist:",
      "SYPAMA Holding GmbH, Turbinenstraße 8, 70499 Stuttgart, Deutschland",
      "Geschäftsführer: Pablo Penzel",
      "E-Mail: sypama.holding@yahoo.com · Telefon: 0151 26739096",
    ],
  },
  {
    h: "2. Hosting und Server-Logdaten",
    p: [
      "Diese Website wird bei einem externen Hosting-Dienstleister (Emergent Labs, USA) betrieben. Beim Aufruf der Website werden durch den Hosting-Anbieter automatisch sogenannte Server-Logdaten verarbeitet: IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Browsertyp und -version, Betriebssystem sowie Referrer-URL.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen Betrieb der Website). Eine Zusammenführung dieser Daten mit anderen Datenquellen findet nicht statt.",
      "Die Logdaten werden nur so lange gespeichert, wie es für den sicheren Betrieb der Website erforderlich ist, und in der Regel nach spätestens 30 Tagen gelöscht.",
      "Hinweis Drittland: Da der Hosting-Anbieter in den USA ansässig sein kann, ist eine Übermittlung personenbezogener Daten in ein Drittland nicht ausgeschlossen. Soweit eine solche Übermittlung erfolgt, geschieht dies auf Grundlage geeigneter Garantien im Sinne der Art. 44 ff. DSGVO (z. B. EU-Standardvertragsklauseln oder eines Angemessenheitsbeschlusses der EU-Kommission).",
      "Hinweis CDN/Sicherheitsdienst: Dem Hosting kann ein Content-Delivery-/Sicherheitsdienst (Cloudflare) vorgeschaltet sein, der zur Bot-Abwehr und Absicherung technisch notwendige Sicherheits-Cookies setzt (z. B. \u201e__cf_bm\u201c, \u201ecf_clearance\u201c). Diese dienen ausschließlich der IT-Sicherheit (§ 25 Abs. 2 TDDDG, Art. 6 Abs. 1 lit. f DSGVO) und enthalten kein nutzerbezogenes Tracking.",
    ],
  },
  {
    h: "3. Cookies und lokale Speicherung (Consent-Verwaltung)",
    p: [
      "Diese Website verwendet keine Tracking-Cookies. Zur Verwaltung Ihrer Datenschutz-Einwilligung wird ein technisch notwendiger Eintrag im lokalen Speicher (localStorage) Ihres Browsers abgelegt: \u201esypama_consent\u201c (Inhalt: Ihre Auswahl, Version der Einwilligung, Zeitpunkt). Dieser Vorgang ist für die Bereitstellung der Website und die Erfüllung rechtlicher Pflichten erforderlich (§ 25 Abs. 2 TDDDG i. V. m. Art. 6 Abs. 1 lit. c und lit. f DSGVO).",
      "Speicherdauer: 12 Monate oder bis zu Ihrem Widerruf über die Cookie-Einstellungen im Footer.",
      "Zur Erfüllung der Nachweispflicht nach Art. 7 Abs. 1 DSGVO wird Ihre Einwilligungsentscheidung zusätzlich pseudonym dokumentiert (zufällige Consent-ID, gewählte Kategorien, Version, Zeitpunkt). Rechtsgrundlage: Art. 6 Abs. 1 lit. c DSGVO.",
      "Alle optionalen Dienste (Statistik, Marketing, externe Medien) sind standardmäßig deaktiviert und werden technisch erst nach Ihrer aktiven Einwilligung geladen (Consent Blocking).",
    ],
  },
  {
    h: "4. Kontaktformular",
    p: [
      "Bei Nutzung des Kontaktformulars verarbeiten wir die von Ihnen eingegebenen Daten: Name, E-Mail-Adresse und Ihre Nachricht. Alle Felder sind Pflichtangaben und auf das zur Bearbeitung Ihrer Anfrage Erforderliche beschränkt.",
      "Zweck: ausschließlich die Bearbeitung und Beantwortung Ihrer Anfrage. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).",
      "Die Daten werden in einer Datenbank beim Hosting-Anbieter gespeichert und nicht zu Marketingzwecken an Dritte weitergegeben. Beim Absenden wird Ihre Anfrage zusätzlich per E-Mail an unsere Kontaktadresse zugestellt (E-Mail-Versanddienstleister: Resend; dabei werden die Formulardaten zur Zustellung verarbeitet). Löschung: nach abschließender Bearbeitung Ihrer Anfrage, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
    ],
  },
  {
    h: "5. Schriftarten und statische Inhalte",
    p: [
      "Sämtliche Schriftarten, Bilder und sonstigen statischen Ressourcen werden lokal von unserem eigenen Server geladen. Es findet keine Verbindung zu externen Anbietern (z. B. Google Fonts) statt; es werden dabei keine Daten an Dritte übertragen.",
    ],
  },
  {
    h: "6. Keine weiteren Drittdienste",
    p: [
      "Diese Website setzt derzeit keine Analyse- oder Trackingtools, keine Marketing-Pixel, keine eingebetteten Videos oder Karten, keine Social-Media-Plugins, kein Captcha, keinen Newsletter-Versand, keine Terminbuchung und keine Zahlungsanbieter ein.",
    ],
  },
  {
    h: "7. Ihre Rechte als betroffene Person",
    p: [
      "Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:",
      "Auskunft (Art. 15 DSGVO) · Berichtigung (Art. 16 DSGVO) · Löschung (Art. 17 DSGVO) · Einschränkung der Verarbeitung (Art. 18 DSGVO) · Datenübertragbarkeit (Art. 20 DSGVO) · Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)",
      "Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an die oben genannten Kontaktdaten.",
    ],
  },
  {
    h: "8. Widerruf Ihrer Einwilligung",
    p: [
      "Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen oder ändern — über den Link \u201eCookie-Einstellungen\u201c im Footer dieser Website. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt unberührt (Art. 7 Abs. 3 DSGVO).",
    ],
  },
  {
    h: "9. Beschwerderecht bei der Aufsichtsbehörde",
    p: [
      "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO). Zuständig ist insbesondere: Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg, Lautenschlagerstraße 20, 70173 Stuttgart.",
    ],
  },
  {
    h: "10. Datensicherheit",
    p: [
      "Diese Website nutzt eine verschlüsselte Übertragung via SSL/TLS (HTTPS), um die Übertragung vertraulicher Inhalte zu schützen.",
    ],
  },
  {
    h: "11. Aktualität dieser Erklärung",
    p: [
      "Diese Datenschutzerklärung hat den unten genannten Stand. Sie wird angepasst, sobald sich die auf dieser Website eingesetzten Technologien oder Verarbeitungen ändern.",
    ],
  },
];
